export function getAssistantInputValues(variables = [], values = {}) {
  return Object.fromEntries(variables.filter((variable) => variable?.name).map((variable) => [
    variable.name,
    String(values[variable.name] ?? variable.defaultValue ?? ''),
  ]));
}
